<style lang="scss" scoped>
@import '@/styles/variables.scss';
.payment-term-box {
	transition: border 0.3s;
	border-radius: $border-radius;
	cursor: pointer;
    text-align: center;
	&.active,
	&:hover {
		border: 1px solid $secondary !important;
	}
}

$font-size-base: 1rem;
$font-size-lg: ($font-size-base * 1.25);
$font-size-sm: ($font-size-base * 0.875);
$input-height: 1.6rem;
$input-btn-focus-width: 0rem;
$custom-control-indicator-bg: #dee2e6;
$custom-control-indicator-disabled-bg: #f8a37e;
$custom-control-description-disabled-color: #dee2e6;
$white: white;
$theme-colors: (
    "primary": #f2644a
);

//
// These variables can be used to customize the switch component.
//
$switch-height: calc(#{$input-height} * 0.8) !default;
$switch-border-radius: $switch-height !default;
$switch-bg: $custom-control-indicator-bg !default;
$switch-checked-bg: map-get($theme-colors, "primary") !default;
$switch-disabled-bg: $custom-control-indicator-disabled-bg !default;
$switch-disabled-color: $custom-control-description-disabled-color !default;
$switch-thumb-bg: $white !default;
$switch-thumb-border-radius: 50% !default;
$switch-thumb-padding: 2px !default;
$switch-focus-box-shadow: 0 0 0 $input-btn-focus-width
    rgba(map-get($theme-colors, "primary"), 0.25);
$switch-transition: 0.2s all !default;

.switch {
    font-size: $font-size-base;
    position: relative;

    input {
        position: absolute;
        height: 1px;
        width: 1px;
        background: none;
        border: 0;
        clip: rect(0 0 0 0);
        clip-path: inset(50%);
        overflow: hidden;
        padding: 0;

        + label {
            position: relative;
            min-width: calc(#{$switch-height} * 2);
            border-radius: $switch-border-radius;
            height: $switch-height;
            line-height: $switch-height;
            display: inline-block;
            cursor: pointer;
            outline: none;
            user-select: none;
            vertical-align: middle;
            text-indent: calc(calc(#{$switch-height} * 2) + 0.5rem);
        }

        + label::before,
        + label::after {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            width: calc(#{$switch-height} * 2);
            bottom: 0;
            display: block;
        }

        + label::before {
            right: 0;
            background-color: $switch-bg;
            border-radius: $switch-border-radius;
            transition: $switch-transition;
        }

        + label::after {
            top: $switch-thumb-padding;
            left: $switch-thumb-padding;
            width: calc(#{$switch-height} - calc(#{$switch-thumb-padding} * 2));
            height: calc(
                #{$switch-height} - calc(#{$switch-thumb-padding} * 2)
            );
            border-radius: $switch-thumb-border-radius;
            background-color: $switch-thumb-bg;
            transition: $switch-transition;
        }

        &:checked + label::before {
            background-color: $switch-checked-bg;
        }

        &:checked + label::after {
            margin-left: $switch-height;
        }

        &:focus + label::before {
            outline: none;
            box-shadow: $switch-focus-box-shadow;
        }

        &:disabled + label {
            color: $switch-disabled-color;
            cursor: not-allowed;
        }

        &:disabled + label::before {
            color: $switch-disabled-color;
        }
        &:checked:disabled + label::before {
            background-color: $switch-disabled-bg;
        }
    }

    + .switch {
        margin-left: 1rem;
    }
}
</style>

<template>
    <box :padding="45" :loading="loading">
        <template slot="content">
            <div class="row">
                <div class="form-group col-md-6">
                    <label for="sb_iban">{{ $t('profile.paymentdetails.sb_iban') }} <span class="ml-auto text-danger">{{ errors.first('company.sb_iban') }}</span></label>
                    <input v-model="payment.company.sb_iban" v-validate="{ regex: /^[A-Z]{2}[0-9]{2}[A-Z0-9]{1,30}$/ }" type="text" name="sb_iban" class="form-control" id="sb_iban">
                </div>    

                <div class="form-group col-md-6">
                    <label for="sb_consent" v-html="$t('register.agreeterms')"></label>                
                    <span class="switch">
                        <input v-model="consentCheck" type="checkbox" class="switch" id="sb_consent" :disabled="!!payment.company.sb_consent">
                        <label for="sb_consent"></label>
                    </span>
                </div>                            
            </div>	

            <div class="row">
                <div class="col-12 fs-12 mb-15">
                    {{ $t('profile.paymentdetails.term') }}
                </div>
                <div class="col-6">
                    <div class="payment-term-box py-45 d-flex border" @click="payment.company.sb_payment_type = '10days'" :class="{ active : payment.company.sb_payment_type === '10days' }">
                        <div class="m-auto">
                            <i-puma class="i-50"></i-puma>
                            <p class="mb-0 text-secondary">{{ $t('profile.paymentdetails.10daysshort') }}</p>
                            <p class="mb-0 text-secondary">{{ $t('profile.paymentdetails.5%short') }}</p>
                        </div>
                    </div>
                </div>
                <div class="col-6">
                    <div class="payment-term-box py-45 d-flex border" @click="payment.company.sb_payment_type = 'waitforsenderpayment'" :class="{ active : payment.company.sb_payment_type === 'waitforsenderpayment' }">
                        <div class="m-auto">
                            <i-rabit class="i-50"></i-rabit>
                            <p class="mb-0 text-secondary">{{ $t('profile.paymentdetails.waitforsenderpaymentshort') }}</p>
                            <p class="mb-0 text-secondary">{{ $t('profile.paymentdetails.nodiscountshort') }}</p>
                        </div>
                    </div>
                </div>
                <!-- <div class="col-4">
                    <div class="payment-term-box py-45 d-flex border" @click="setPaymentType('7days')" :class="{ active : payment.company.invoice_payment_type === '7days' }">
                        <div class="m-auto">
                            <i-puma class="i-50"></i-puma>
                            <p class="mb-0 text-secondary">{{ $t('profile.paymentdetails.7daysshort') }}</p>
                            <p class="mb-0 text-secondary">{{ $t('profile.paymentdetails.5%short') }}</p>
                        </div>
                    </div>
                </div>
                <div class="col-4">
                    <div class="payment-term-box py-45 d-flex border" @click="setPaymentType('30days')" :class="{ active : payment.company.invoice_payment_type === '30days' }">
                        <div class="m-auto">
                            <i-rabit class="i-50"></i-rabit>
                            <p class="mb-0 text-secondary">{{ $t('profile.paymentdetails.30daysshort') }}</p>
                            <p class="mb-0 text-secondary">{{ $t('profile.paymentdetails.2%short') }}</p>
                        </div>
                    </div>
                </div>
                <div class="col-4">
                    <div class="payment-term-box py-45 d-flex border" @click="setPaymentType('60days')" :class="{ active : payment.company.invoice_payment_type === '60days' }">
                        <div class="m-auto">
                            <i-turtle class="i-50"> </i-turtle>
                            <p class="mb-0 text-secondary">{{ $t('profile.paymentdetails.60daysshort') }}</p>
                            <p class="mb-0 text-secondary">{{ $t('profile.paymentdetails.nodiscountshort') }}</p>
                        </div>
                    </div>
                </div> -->                
            </div>
            <disclaimer v-if="payment.company.sb_payment_type">{{ $t(`profile.paymentdetails.${payment.company.sb_payment_type}`) }}</disclaimer>                        

            <div class="row">                
                <div class="form-group col-md-6">
                    <label></label>
                    <button class="btn btn-primary mr-30" :disabled="!payment.company.sb_consent" @click="submit">{{ $t('bin.save') }}</button>
                </div>     
            </div>  
        </template>
    </box>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
	name: 'profile-payment',
	data() {
		return {
			payment: {
				id: '',
				company: {
					id: '',
					sb_payment_type: '',
                    sb_consent: null,
					sb_iban: '',
					address: {
						id: ''
					}
				}
			},
			loading: true
		}
	},
	mounted() {
		this.initFields()
	},
	methods: {
		...mapActions(["updateUser"]),
		initFields() {
			if (this.user) {
				this.payment.id = this.user.id
				this.payment.company.id = this.user.company.id
				this.payment.company.sb_iban = this.user.company.sb_iban
                this.payment.company.sb_consent = this.user.company.sb_consent
				this.payment.company.sb_payment_type = this.user.company.sb_payment_type				
				this.payment.company.address.id = this.user.company.address.id;				
				this.loading = false
			}
		},

        submit() {
            this.$validator.validateAll().then(res => {
                if (res) {            
                    this.updateUser(this.payment)
                    .then(resp => {
                        this.$toasted.show(this.$t('profile.toast.savesuccess'));                   
                        this.initFields() 
                    })
                    .catch(err => {                
                        this.$toasted.show(err.response.data[0].message);
                    });                
                }
            });
        }
	},
	computed: {
        ...mapGetters(['user']),
        consentCheck: {
             // getter
            get: function () {
                return !!this.payment.company.sb_consent
            },
            // setter
            set: function () {
                this.payment.company.sb_consent = this.$moment().format('X');
            }
        }
    },    
	watch: {
		user: function() {
			this.initFields()
		}
	}
}
</script>
